<ng-container *ngIf="Translated$ | async as translated">{{translated}}</ng-container>